module.exports = __webpack_public_path__ + "media/images/lb/489-cbf77749d484e149b18276606f448165.svg";